export const USER_MANUAL_URL = 'https://wiki.intranet.uniper.energy/sales/x/o4NPDQ' as const
